<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<div class="user-profile-container">
  <!-- User profile image -->
  <!-- <div class="profile-img">
  <img src="assets/images/users/profile.png" alt="user"> </div> -->
  <!-- User profile text-->
  <!-- ============================================================== -->
  <!-- Profile - style you can find in header.scss -->
  <!-- ============================================================== -->
  <!-- <div class="profile-text">
  <a [matMenuTriggerFor]="sdprofile" class=""> Markarn Doe
    <i class="ti-angle-down font-12 m-l-5"></i>
  </a>
</div> -->
<mat-menu #sdprofile="matMenu" class="mymegamenu">
  <button mat-menu-item>
    <mat-icon>exit_to_app</mat-icon> Sign Out
  </button>
</mat-menu>
</div>
<mat-nav-list appAccordion>
  @for (menuitem of menuItems.mainMenuItems$ | async; track menuitem) {
    <mat-list-item appAccordionLink routerLinkActive="selected" group="{{menuitem.state}}"
      [odqHideMenuIfUnauthorized]="menuitem" (click)="onItemClick()">
      @if (menuitem.type === 'link') {
        <a class="" appAccordionToggle [routerLink]="['/', menuitem.state]">
          <mat-icon>{{ menuitem.icon }}</mat-icon>
          <span>{{ menuitem.name | translate }}</span>
          <span style="flex: 1 1 0%"></span>
          @for (badge of menuitem.badge; track badge) {
            <span class="label label-{{ badge.type }}">{{ badge.value }}</span>
          }
        </a>
      }
      @if (menuitem.type === 'extLink') {
        <a class="" appAccordionToggle href="{{menuitem.state}}">
          <mat-icon>{{ menuitem.icon }}</mat-icon>
          <span>{{ menuitem.name }}</span>
          <span style="flex: 1 1 0%"></span>
          @for (badge of menuitem.badge; track badge) {
            <span class="label label-{{ badge.type }}">{{ badge.value }}</span>
          }
        </a>
      }
      @if (menuitem.type === 'extTabLink') {
        <a class="" appAccordionToggle href="{{menuitem.state}}" target="_blank">
          <mat-icon>{{ menuitem.icon }}</mat-icon>
          <span>{{ menuitem.name}}</span>
          <span style="flex: 1 1 0%"></span>
          @for (badge of menuitem.badge; track badge) {
            <span class="label label-{{ badge.type }}">{{ badge.value }}</span>
          }
        </a>
      }
      @if (menuitem.type === 'sub') {
        <a class="" appAccordionToggle href="javascript:;">
          <mat-icon>{{ menuitem.icon }}</mat-icon>
          <span>{{ menuitem.name | translate }}</span>
          <span style="flex: 1 1 0%"></span>
          @for (badge of menuitem.badge; track badge) {
            <span class="label label-{{ badge.type }}">{{ badge.value }}</span>
          }
          <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
        </a>
      }
      @if (menuitem.type === 'sub') {
        <mat-nav-list class="sub-item">
          @for (childitem of menuitem.children; track childitem) {
            <mat-list-item routerLinkActive="selected" (click)="onItemClick()">
              <a [routerLink]="['/', menuitem.state, childitem.state ]" class="relative" routerLinkActive="selected">{{
              childitem.name | translate}}</a>
            </mat-list-item>
          }
        </mat-nav-list>
      }
      @if (menuitem.type === 'secure-messages') {
        <a class="" appAccordionToggle [routerLink]="['/', menuitem.state]">
          <mat-icon>{{ menuitem.icon }}</mat-icon>
          <span>{{ menuitem.name | translate }}</span>
          <span style="flex: 1 1 0%"></span>
          @if (secureMessagesNav.totalUnread$ | async; as totalUnread) {
            <span class="unread-badge">{{ totalUnread }}</span>
          }
          <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
        </a>
        <mat-nav-list class="sub-item secure-messages-tree">
          @for (group of secureMessageGroups; track group.key) {
            <div class="sm-group">
              <div class="sm-group-title">
                <mat-icon>folder</mat-icon>
                <span>{{ group.labelKey | translate }}</span>
              </div>
              @for (category of group.categories; track category.key) {
                @if (category.enabled) {
                  <a class="sm-category" routerLinkActive="selected" (click)="onItemClick()"
                    [routerLink]="['/', menuitem.state, group.key, category.key]">
                    <span class="sm-category-label">
                      <mat-icon fontSet="material-icons-outlined">insert_drive_file</mat-icon>
                      {{ category.labelKey | translate }}
                    </span>
                    @if ((secureMessagesNav.unreadByCategory$ | async)?.[category.key]; as unread) {
                      <span class="unread-badge">{{ unread }}</span>
                    }
                  </a>
                } @else {
                  <span class="sm-category disabled">
                    <span>{{ category.labelKey | translate }}</span>
                    <span class="coming-soon">{{ 'secureMessages.comingSoon' | translate }}</span>
                  </span>
                }
              }
            </div>
          }
        </mat-nav-list>
      }
      @if (menuitem.type === 'saperator') {
        <div class="saperator text-muted">
          <span>{{ menuitem.name | translate }}</span>
        </div>
      }
    </mat-list-item>
  }
</mat-nav-list>